const translations: Record<string, string> = {
  // Common
  'common:siteName': 'Alat PDF Gratis',
  'common:nav.home': 'Beranda',
  'common:nav.pdfToWord': 'PDF ke Word',
  'common:nav.pdfToExcel': 'PDF ke Excel',
  'common:nav.pdfToPpt': 'PDF ke PPT',
  'common:nav.imageConvert': 'Konversi Gambar',
  'common:nav.pdfTools': 'Alat PDF',
  'common:nav.tutorials': 'Tutorial',
  'common:nav.faq': 'FAQ',

  // Footer
  'common:footer.description': 'Alat PDF gratis terbaik untuk semua kebutuhan konversi dan pengeditan PDF Anda. Tanpa registrasi.',
  'common:footer.quickLinks': 'Tautan Cepat',
  'common:footer.about': 'Tentang',
  'common:footer.aboutUs': 'Tentang Kami',
  'common:footer.tutorials': 'Tutorial',
  'common:footer.faq': 'FAQ',
  'common:footer.privacyPolicy': 'Kebijakan Privasi',
  'common:footer.subscribe': 'Newsletter',
  'common:footer.subscribeNote': 'Dapatkan tips dan pembaruan terbaru.',
  'common:footer.subscribePlaceholder': 'Masukkan email Anda',
  'common:footer.subscribeButton': 'Berlangganan',
  'common:footer.subscribing': 'Mendaftar...',
  'common:footer.subscribeSuccess': '✓ Berhasil berlangganan!',
  'common:footer.subscribeFailed': 'Gagal berlangganan, coba lagi.',
  'common:footer.subscribeError': 'Kesalahan jaringan, coba lagi.',
  'common:footer.adSpace': 'Ruang Iklan',
  'common:footer.copyright': '© 2024 Alat PDF Gratis. Semua hak dilindungi.',

  // Features section
  'common:features.pdfToDoc': 'PDF ke Dokumen',
  'common:features.pdfToDocDesc': 'Konversi PDF ke Word, Excel, PPT dan format yang dapat diedit lainnya.',
  'common:features.imageToPdf': 'Gambar ke PDF',
  'common:features.imageToPdfDesc': 'Gabungkan beberapa gambar menjadi satu file PDF dengan mudah.',
  'common:features.pdfMerge': 'Gabung & Pisah PDF',
  'common:features.pdfMergeDesc': 'Gabungkan beberapa PDF atau pisahkan satu PDF menjadi file terpisah.',
  'common:features.startConvert': 'Mulai Konversi',
  'common:features.useNow': 'Gunakan Sekarang',
  'common:features.mostPopular': 'Paling Populer',

  // Hero section
  'home:hero.title': 'Alat PDF Gratis Online',
  'home:hero.subtitle': 'Konversi, edit, dan kelola file PDF Anda dengan mudah. Tidak perlu registrasi, 100% gratis!',
  'home:hero.free': 'Gratis Selamanya',
  'home:hero.noRegistration': 'Tanpa Registrasi',
  'home:hero.secure': 'Aman & Privat',
  'home:hero.startConverting': 'Mulai Konversi',
  'home:hero.viewAllTools': 'Lihat Semua Alat',
  'home:hero.stats.users': 'Pengguna Puas',
  'home:hero.stats.conversions': 'File Dikonversi',
  'home:hero.stats.rating': 'Rating Pengguna',

  // All Tools section
  'home:allTools.title': 'Semua Alat PDF',
  'home:allTools.subtitle': 'Semua yang Anda butuhkan untuk bekerja dengan file PDF, sepenuhnya gratis.',
  'home:allTools.tryNow': 'Coba Sekarang',
  'home:tools.pdfToWord.name': 'PDF ke Word',
  'home:tools.pdfToWord.description': 'Konversi PDF ke dokumen Word yang dapat diedit.',
  'home:tools.pdfToExcel.name': 'PDF ke Excel',
  'home:tools.pdfToExcel.description': 'Ekstrak tabel dari PDF ke spreadsheet Excel.',
  'home:tools.pdfToPpt.name': 'PDF ke PPT',
  'home:tools.pdfToPpt.description': 'Ubah PDF menjadi presentasi PowerPoint.',
  'home:tools.pdfToImage.name': 'PDF ke Gambar',
  'home:tools.pdfToImage.description': 'Konversi halaman PDF ke gambar JPG atau PNG.',
  'home:tools.imageToPdf.name': 'Gambar ke PDF',
  'home:tools.imageToPdf.description': 'Gabungkan gambar menjadi satu file PDF.',
  'home:tools.mergePdf.name': 'Gabungkan PDF',
  'home:tools.mergePdf.description': 'Gabungkan beberapa file PDF menjadi satu.',
  'home:tools.splitPdf.name': 'Pisahkan PDF',
  'home:tools.splitPdf.description': 'Ekstrak halaman dari file PDF.',
  'home:tools.compressPdf.name': 'Kompres PDF',
  'home:tools.compressPdf.description': 'Kurangi ukuran file PDF tanpa kehilangan kualitas.',

  // Why Us section
  'home:whyUs.title': 'Mengapa Memilih Kami?',
  'home:whyUs.subtitle': 'Kami menyediakan alat PDF gratis terbaik tanpa biaya tersembunyi atau registrasi.',
  'home:whyUs.free.title': '100% Gratis',
  'home:whyUs.free.description': 'Semua alat sepenuhnya gratis. Tidak ada biaya tersembunyi, tidak ada langganan.',
  'home:whyUs.fast.title': 'Super Cepat',
  'home:whyUs.fast.description': 'Server kami memproses file Anda dalam hitungan detik.',
  'home:whyUs.secure.title': 'Aman & Privat',
  'home:whyUs.secure.description': 'File Anda dihapus otomatis setelah konversi.',
  'home:whyUs.easy.title': 'Mudah Digunakan',
  'home:whyUs.easy.description': 'Antarmuka drag-and-drop sederhana, tidak perlu keahlian teknis.',
  'home:whyUs.cta.title': 'Siap Memulai?',
  'home:whyUs.cta.description': 'Bergabunglah dengan jutaan pengguna yang mempercayai alat PDF gratis kami setiap hari.',
  'home:whyUs.cta.button': 'Coba Gratis Sekarang',

  // Testimonials section
  'home:testimonials.title': 'Apa Kata Pengguna',
  'home:testimonials.subtitle': 'Dipercaya oleh jutaan pengguna di seluruh dunia.',
  'home:testimonials.trustedBy': 'Dipercaya dan disertifikasi oleh',
  'home:testimonials.badges.secure': 'SSL Aman',
  'home:testimonials.badges.verified': 'Terverifikasi Aman',
  'home:testimonials.badges.award': 'Alat Terbaik',
  'home:testimonials.user1.name': 'Sarah Johnson',
  'home:testimonials.user1.role': 'Manajer Pemasaran',
  'home:testimonials.user1.content': 'Ini adalah alat PDF gratis terbaik yang pernah saya gunakan. Cepat, andal, dan tidak perlu registrasi yang menjengkelkan!',
  'home:testimonials.user2.name': 'Emily Chen',
  'home:testimonials.user2.role': 'Desainer Freelance',
  'home:testimonials.user2.content': 'Saya mengonversi PDF ke Word setiap hari untuk klien saya. Alat ini menghemat banyak waktu dan sepenuhnya gratis!',
  'home:testimonials.user3.name': 'Michael Torres',
  'home:testimonials.user3.role': 'Analis Bisnis',
  'home:testimonials.user3.content': 'Fitur PDF ke Excel sangat akurat. Ini mengekstrak tabel dengan sempurna setiap saat.',

  // Ads
  'home:ads.topBanner': 'Iklan',
  'home:ads.middleBanner': 'Iklan',

  // Upload
  'upload:dragDrop': 'Seret & Lepas file PDF Anda di sini',
  'upload:or': 'atau',
  'upload:selectFile': 'Pilih File',
  'upload:processing': 'Memproses...',
  'upload:converting': 'Mengonversi file Anda...',
  'upload:done': 'Selesai!',
  'upload:success': 'File Anda berhasil dikonversi',
  'upload:download': 'Unduh File',
  'upload:convertAnother': 'Konversi File Lain',
  'upload:fileSize': 'Ukuran file maksimal: 10MB',
  'upload:supportedFormats': 'Format yang didukung',

  // PDF to Word
  'pdfToWord:title': 'PDF ke Word',
  'pdfToWord:description': 'Konversi file PDF Anda ke dokumen Word yang dapat diedit secara gratis',
  'pdfToWord:feature1.title': 'Konversi Cepat',
  'pdfToWord:feature1.desc': 'Konversi PDF ke Word dalam hitungan detik',
  'pdfToWord:feature2.title': 'Kualitas Tinggi',
  'pdfToWord:feature2.desc': 'Pertahankan format dan tata letak asli',
  'pdfToWord:feature3.title': '100% Gratis',
  'pdfToWord:feature3.desc': 'Tidak perlu registrasi atau pembayaran',
  'pdfToWord:howTo.title': 'Cara Menggunakan',
  'pdfToWord:howTo.step1': 'Unggah file PDF Anda',
  'pdfToWord:howTo.step2': 'Tunggu proses konversi',
  'pdfToWord:howTo.step3': 'Unduh file Word Anda',

  // PDF to Excel
  'pdfToExcel:title': 'PDF ke Excel',
  'pdfToExcel:description': 'Konversi tabel PDF ke spreadsheet Excel yang dapat diedit',
  'pdfToExcel:feature1.title': 'Ekstrak Tabel',
  'pdfToExcel:feature1.desc': 'Ekstrak tabel dari PDF secara otomatis',
  'pdfToExcel:feature2.title': 'Data Akurat',
  'pdfToExcel:feature2.desc': 'Pertahankan struktur data asli',
  'pdfToExcel:feature3.title': 'Mudah Digunakan',
  'pdfToExcel:feature3.desc': 'Antarmuka sederhana dan intuitif',
  'pdfToExcel:howTo.title': 'Cara Menggunakan',
  'pdfToExcel:howTo.step1': 'Unggah file PDF dengan tabel',
  'pdfToExcel:howTo.step2': 'Sistem akan mengekstrak tabel',
  'pdfToExcel:howTo.step3': 'Unduh file Excel Anda',

  // PDF to PPT
  'pdfToPpt:title': 'PDF ke PowerPoint',
  'pdfToPpt:description': 'Ubah PDF Anda menjadi presentasi PowerPoint yang dapat diedit',
  'pdfToPpt:feature1.title': 'Konversi Slide',
  'pdfToPpt:feature1.desc': 'Setiap halaman PDF menjadi slide PPT',
  'pdfToPpt:feature2.title': 'Dapat Diedit',
  'pdfToPpt:feature2.desc': 'Edit teks dan gambar setelah konversi',
  'pdfToPpt:feature3.title': 'Aman & Pribadi',
  'pdfToPpt:feature3.desc': 'File Anda dihapus setelah konversi',
  'pdfToPpt:howTo.title': 'Cara Menggunakan',
  'pdfToPpt:howTo.step1': 'Pilih file PDF Anda',
  'pdfToPpt:howTo.step2': 'Konversi ke format PPT',
  'pdfToPpt:howTo.step3': 'Unduh presentasi Anda',

  // Image Convert
  'imageConvert:title': 'Konversi Gambar',
  'imageConvert:description': 'Konversi gambar ke PDF atau PDF ke gambar dengan mudah',
  'imageConvert:feature1.title': 'Multi-Format',
  'imageConvert:feature1.desc': 'Mendukung JPG, PNG, BMP, GIF',
  'imageConvert:feature2.title': 'Batch Convert',
  'imageConvert:feature2.desc': 'Konversi beberapa gambar sekaligus',
  'imageConvert:feature3.title': 'Kualitas Terjaga',
  'imageConvert:feature3.desc': 'Tidak ada kehilangan kualitas gambar',
  'imageConvert:howTo.title': 'Cara Menggunakan',
  'imageConvert:howTo.step1': 'Unggah gambar atau PDF',
  'imageConvert:howTo.step2': 'Pilih format output',
  'imageConvert:howTo.step3': 'Unduh hasil konversi',

  // PDF Tools
  'pdfToolsPage:title': 'Alat PDF Lengkap',
  'pdfToolsPage:description': 'Gabungkan, pisahkan, kompres, dan edit file PDF Anda',
  'pdfToolsPage:feature1.title': 'Gabungkan PDF',
  'pdfToolsPage:feature1.desc': 'Gabungkan beberapa PDF menjadi satu',
  'pdfToolsPage:feature2.title': 'Pisahkan PDF',
  'pdfToolsPage:feature2.desc': 'Ekstrak halaman dari PDF',
  'pdfToolsPage:feature3.title': 'Kompres PDF',
  'pdfToolsPage:feature3.desc': 'Kurangi ukuran file PDF',
  'pdfToolsPage:howTo.title': 'Cara Menggunakan',
  'pdfToolsPage:howTo.step1': 'Pilih alat yang Anda butuhkan',
  'pdfToolsPage:howTo.step2': 'Unggah file PDF Anda',
  'pdfToolsPage:howTo.step3': 'Unduh hasil yang diproses',
};

export default translations;
